import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";
export const GET_FOOD_CATEGORIES = "GET_FOOD_CATEGORIES";

export function getFoodCategories(token) {
  const request = axios.get(
    "/food-categories/",
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_FOOD_CATEGORIES,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}



// WEBPACK FOOTER //
// ./src/store/actions/foodCategories.js